module.exports = __webpack_public_path__ + "img/202004-1.d3ccf2a6.png";